import { ApiClient } from '../apiClient';
import { BalanceLedgerEntry, BalanceSummary } from '../../types/balance';
import { PaginationDto } from '../../types/pagination';

export class BalanceService {
  constructor(private apiClient: ApiClient) {}

  async getMyBalance(): Promise<BalanceSummary> {
    return this.apiClient.get<BalanceSummary>('/user-balance');
  }

  async getMyHistory(page = 0, limit = 25): Promise<PaginationDto<BalanceLedgerEntry>> {
    return this.apiClient.post<PaginationDto<BalanceLedgerEntry>>(
      '/user-balance/history',
      {
        page,
        limit,
        sortBy: { createdAt: -1 },
      },
    );
  }
}
